// extracted by mini-css-extract-plugin
export var formContainer = "_gq-0";
export var message = "_gq-1";